const $ = jQuery.noConflict();

function ScrollableLetters() {
    let clicked = false;
    let base = 0;

    $('.scrollbar-external').scrollbar({
        "autoScrollSize": false,
        "scrollx": $('.external-scroll_x'),
    });
}

function dragScroll() {

    let clicked = false;
    let clickX;
    let scrollPos = 0;

    $('.scrollbar-external').on({
        mousemove: function(e) {
            clicked && $(this).scrollLeft(scrollPos + (clickX - e.pageX));
        },
        mousedown: function(e) {
            clicked = true;
            clickX = e.pageX;
        },
        mouseup: function(e) {
            e.stopPropagation();
            clicked = false;
            scrollPos = $(this).scrollLeft();
        },
    });
}

export { ScrollableLetters, dragScroll };
